import { render } from "./UserCriteriaList.vue?vue&type=template&id=58344a45"
import script from "./UserCriteriaList.vue?vue&type=script&lang=js"
export * from "./UserCriteriaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__